<template>
	<div class="layout-wrapper">
		<section class="page-panel">
			<ui-header :sidebar="false" />
			<section class="body">
				<section class="content">
					<ui-breadcrumbs design="full" :container="false">
						<template #left>
							<router-link :to="moduleLink">
								<span>{{ moduleName }}</span>
							</router-link>
							<router-link :to="titleLink">
								<span> &#8226; {{ title }}</span>
							</router-link>
							<span v-if="subtitle"> &#8226; {{ subtitle }}</span>
						</template>
					</ui-breadcrumbs>
					<section v-scroll-paginate="scrollHandler" class="page scroll-color">
						<slot name="page" />
					</section>
				</section>
				<slot />
			</section>
	
			<ui-feedback-modal />
			<ui-thank-feedback-modal />
			<ui-active-offer-modal />
			<uiRatingNPS />
		</section>
		<slot name="footer"/>
	</div>
</template>

<script>
import uiHeader from '@/components/ui/panel-header'
import uiFeedbackModal from '@/components/ui-facilita/modals/feedback-modal'
import uiThankFeedbackModal from '@/components/ui-facilita/modals/feedback-modal/thank-feedback-modal'
import uiRatingNPS from '@/components/ui-facilita/rating/nps/index.vue'
import { uiBreadcrumbs } from '@/components/ui'
import { uiActiveOfferModal } from '@/components/ui-facilita/active-offer'
import { scrollPaginate } from '@/directives'
import { storage } from '@/services/storage'
import { mapGetters } from 'vuex'

export default {
	name: 'page-configurations',

	components: {
		uiHeader,
		uiActiveOfferModal,
		uiBreadcrumbs,
		uiRatingNPS,
		uiFeedbackModal,
		uiThankFeedbackModal
	},

	directives: {
		scrollPaginate,
	},

	props: {
		moduleName: {
			type: String,
			default: ''
		},
		title: {
			type: String,
			default: ''
		},
		subtitle: {
			type: String,
			default: ''
		},
		iconMenuCard: {
			type: String,
			default: 'far fa-ellipsis-v',
		},
		showActions: {
			type: Boolean,
			default: false,
		},
		moduleLink: {
			type: [String, Object],
			required: false,
			default: '/'
		},
		titleLink: {
			type: [String, Object],
			required: false,
			default: '/'
		}
	},

	data() {
		return {
			
		}
	},

	computed: {
		...mapGetters('auth', {
			user: 'getUser',
		}),
	},

	beforeCreate() {
		this.$nextTick(() => {
			const companiesRestricted = this.$store.getters.companiesRestricted
			let user = JSON.parse(storage.get('user_logged'))
			let config = JSON.parse(storage.get('api_config'))

			window.dataLayer[0].user 				 = user
			window.dataLayer[0].configs 			 = JSON.parse(storage.get('get-configs-data'))
			window.dataLayer[0].companies_restricted = companiesRestricted
			window.dataLayer[0].instance_user_id 	 = config.instance + '_' + user.id
			window.dataLayer[0].instance 	 		 = config.instance
		})
	},

	methods: {
		scrollHandler() {
			this.$root.$emit('scroll-handler')
		}
	}
}
</script>

<style lang="stylus" scoped>
@import 'styles.styl';
</style>

